module.exports = __webpack_public_path__ + "static/media/karaoke_01.88d4f41f.svg";